export { default as MainSlider } from './MainSlider';
export { default as SiteMapSection } from './SiteMapSection';
export { default as DeliveringIndustrySolutions } from './DeliveringIndustrySolutions';
export { default as BusinessQualities } from './BusinessQualities';
export { default as OurCompanyText } from './OurCompanyText';
